import TableChartSidebar from 'components/Table/TableChartSidebar';
import { BallStrikeSummaryDto, BatterReportChartConfigDto, TableChartConfigDto } from 'types/CodegenReportTypes';
import { ChartConfigProps } from 'utilities/chartIdToComponent';

const disabledVisibleStats: (keyof BallStrikeSummaryDto)[] = ['count'];

const BatterBallStrikeSummaryChartSidebar = (props: ChartConfigProps<TableChartConfigDto, BatterReportChartConfigDto>) => {
  return (
    <TableChartSidebar
      chartId='BatterBallStrikeSummaryChart'
      chartKey='batterBallStrikeSummaryChartConfig'
      disabledVisibleStats={disabledVisibleStats}
      {...props}
    />
  );
};

export default BatterBallStrikeSummaryChartSidebar;
